export class SchemeError extends Error {
    desiredScheme: string

    constructor(message: string, desiredScheme: string) {
        super(message);
        this.desiredScheme = desiredScheme
    }
}

export function desiredUrl(desiredScheme: string) {
    const currentUrl = window.location.href
    return currentUrl.replace(window.location.protocol, desiredScheme + ":")
}

export function checkScheme(uri: string): [isCurrent: boolean, desiredScheme: string, currentScheme: string] {
    const currentScheme = window.location.protocol.replace(":", "")
    try {
        new URL(uri) // throws if invalid
        const desiredScheme = uri.startsWith('http://') ? 'http' : 'https'
        return [currentScheme === desiredScheme, desiredScheme, currentScheme]
    } catch (error) {
        console.debug("Attempted to check scheme on invalid url, this is not a bug but a bad url", error)
        return [false, "ERROR", currentScheme]
    }
}